<template>
  <layout-component>
    <div class="banner banner-booking-success">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h1 class="left-bullet" v-html="$t('w.booking-success.title-banner')"></h1>
            <p>{{ 'w.booking-success.text-01'|t }}</p>

            <router-link class="btn" to="/dashboard" active-class="active"><span>{{ 'w.booking-success.title-btn-big'|t }}</span></router-link>

            <div class="banner banner-booking-success-links-section first">
              <h3>{{ $t('w.booking-success.title-next') }}</h3>

              <div class="cta-wrapper">
                <router-link class="btn-link mb-0" to="/book" active-class="active">{{ 'w.booking-success.cta-room'|t }}</router-link>
                <router-link class="btn-link mb-0" to="/events" active-class="active">{{ 'w.booking-success.cta-event'|t }}</router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
    export default {
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
      }
    }
</script>
